<template>
  <teleport to="#modalTeleport">
    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </teleport>
  <HeadlineComponent :subtitle="`${shifts.filled} von ${shifts.total} belegt`"
    >Teams</HeadlineComponent
  >
  <div class="form-check mb-3">
    <input
      type="checkbox"
      v-model="all_events"
      @change="refresh()"
      id="all_events"
      class="form-check-input"
    />
    <label class="form-check-label" for="all_events">
      Auch vergangene Veranstaltungen zeigen
    </label>
  </div>
  <div class="m-3 text-center">
    Schichten mit einem <span class="fa fa-bookmark"></span> wurden von dem
    angezeigten Admin reserviert.
  </div>
  <div class="mb-4" v-if="events.length > 1">
    <label for="event_select">Event Auswählen</label>
    <select
      id="event_select"
      v-model="event_id"
      class="form-control"
      @change="updateEvent()"
    >
      <option>--- Auswählen ---</option>
      <option v-for="e of events" :key="e.id" :value="e.id">
        {{ e.name }}
      </option>
    </select>
  </div>
  <div class="mb-4 form-row align-items-center">
    <div class="col-md-9">
      <label class="sr-only" for="teams-filter">Filter Teams</label>
      <input
        type="text"
        class="form-control"
        id="teams-filter"
        placeholder="Filter Teams"
        v-model="teamFilter"
      />
    </div>
    <div class="col-md-3">
      <div class="form-check">
        <input
          type="checkbox"
          v-model="onlyMine"
          id="onlyMine"
          class="form-check-input"
        />
        <label class="form-check-label" for="onlyMine">
          Nur meine Teams anzeigen
        </label>
      </div>
    </div>
  </div>
  <RouterLink
    :to="`/teams/${event_id}/create`"
    class="btn btn-sm btn-primary mb-3"
    v-if="event_id && isAdmin"
    ><span class="fa fa-plus"></span> Team
  </RouterLink>
  <div v-for="team of filteredTeams" :key="team.id">
    <h2 class="mt-1">
      <div
        class="btn-group btn-group-sm mr-3 align-middle"
        v-if="isTeamlead(team) || isAdmin"
      >
        <RouterLink
          :to="`/teams/${event_id}/${team.id}/create`"
          v-if="isTeamlead(team) || isAdmin"
          class="btn btn-outline-secondary btn-sm"
          ><span class="fa fa-plus"></span> Aufgabe</RouterLink
        >
        <button
          @click="deleteTeam(team)"
          v-if="isAdmin"
          class="btn btn-outline-danger btn-sm"
        >
          <span class="fa fa-trash"></span>
        </button>
      </div>
      <RouterLink
        v-if="isAdmin"
        :to="`/teams/${event_id}/${team.id}`"
        class="align-middle"
        >{{ team.name }}</RouterLink
      >
      <span v-if="!isAdmin" class="align-middle">{{ team.name }}</span>
      <br />
      <small v-if="team.teamleads"
        ><span
          v-for="teamlead of team.teamleads"
          :key="teamlead.id"
          class="comma-after"
          >{{ teamlead.full_name }}</span
        ></small
      >
    </h2>
    <div
      v-html="team.description"
      class="quill-generated-text team-description"
      v-if="team.description"
    ></div>
    <div class="row mt-3" v-for="(task, i) of team.tasks" :key="task.id">
      <template v-if="i % 3 === 0">
        <div class="col-lg" v-for="y of [0, 1, 2]" :key="y">
          <template v-if="team.tasks[i + y]">
            <h3>
              <div
                class="btn-group btn-group-sm mr-2 align-middle"
                v-if="isTeamlead(team) || isAdmin"
              >
                <RouterLink
                  :to="`/teams/${event_id}/${team.id}/create/${team.tasks[i + y].id}`"
                  class="btn btn-outline-secondary btn-sm"
                  v-if="isTeamlead(team) || isAdmin"
                  ><span class="fa fa-copy"></span
                ></RouterLink>
                <button
                  class="btn btn-outline-danger btn-sm"
                  @click="deleteTask(team.tasks[i + y], team)"
                  v-if="isTeamlead(team) || isAdmin"
                >
                  <span class="fa fa-trash"></span>
                </button>
              </div>
              <RouterLink
                class="align-middle"
                :to="`/teams/${event_id}/${team.id}/update/${team.tasks[i + y].id}`"
                v-if="isTeamlead(team) || isAdmin"
                >{{ team.tasks[i + y].name }}</RouterLink
              >
              <span v-if="!isTeamlead(team) && !isAdmin" class="align-middle">{{
                team.tasks[i + y].name
              }}</span>
            </h3>
            <div
              class="quill-generated-text task-description"
              v-html="team.tasks[i + y].description"
              v-if="team.tasks[i + y].description"
            ></div>
            <table class="table">
              <tbody>
                <tr
                  v-for="shift of team.tasks[i + y].shifts"
                  :key="shift.id"
                  :class="{
                    highlight: highlight == shift.id,
                    'shift-showed-up': shift.showed_up_set && shift.showed_up,
                    'shift-not-showed-up':
                      shift.showed_up_set && !shift.showed_up,
                  }"
                  :ref="shift.id"
                >
                  <td style="line-height: 0.8">
                    {{ $filters.formatDate(shift.start, "HH:mm") }} -
                    {{ $filters.formatDate(shift.end, "HH:mm") }}<br />
                    <small style="font-size: x-small"
                      >{{ $filters.formatDate(shift.start, "dd DD.MM.YYYY") }} -
                      {{
                        $filters.formatDate(shift.end, "dd DD.MM.YYYY")
                      }}</small
                    >
                  </td>
                  <td
                    v-if="shift.user && !editing[shift.id]"
                    style="text-align: right"
                  >
                    <span
                      class="fa fa-bookmark pr-1"
                      v-if="shift.reserved"
                    ></span>
                    <RouterLink
                      :to="`/user/${shift.user.id}`"
                      v-if="
                        !shift.reserved_first_name &&
                        !shift.reserved_last_name &&
                        isAdmin
                      "
                    >
                      <span class="fa fa-user pr-1"></span
                      >{{ shift.user.full_name }}
                    </RouterLink>
                    <span
                      v-if="
                        !shift.reserved_first_name &&
                        !shift.reserved_last_name &&
                        !isAdmin
                      "
                    >
                      <span class="fa fa-user pr-1"></span
                      >{{ shift.user.full_name }}</span
                    >
                    <span
                      v-if="
                        shift.reserved_first_name && shift.reserved_last_name
                      "
                      >{{ shift.reserved_first_name }}
                      {{ shift.reserved_last_name }}.</span
                    >
                    <a
                      href="#"
                      @click="cancelShift(team.id, shift)"
                      v-if="isTeamlead(team) || isAdmin"
                      ><span class="fa fa-close pl-1"></span
                    ></a>
                    <template
                      v-if="
                        (isTeamlead(team) || isAdmin) &&
                        !shift.showed_up_set &&
                        shiftHasStarted(shift)
                      "
                    >
                      <br />
                      <small>Ist aufgetaucht?</small>
                      <div class="btn-group ml-1">
                        <button
                          class="btn btn-sm btn-success"
                          @click="setHasArrived(shift, team.id, true)"
                        >
                          <span class="fa fa-check"></span>
                        </button>
                        <button
                          class="btn btn-sm btn-danger"
                          @click="setHasArrived(shift, team.id, false)"
                        >
                          <span class="fa fa-close"></span>
                        </button>
                      </div>
                    </template>
                  </td>
                  <td
                    v-if="
                      !shift.user && !editing[shift.id] && !reserving[shift.id]
                    "
                    style="text-align: right"
                  >
                    <button
                      @click="editing[shift.id] = true"
                      class="btn btn-light btn-sm mr-1"
                      v-if="isTeamlead(team) || isAdmin"
                    >
                      Zuweisen
                    </button>
                    <button
                      @click="reserving[shift.id] = true"
                      class="btn btn-light btn-sm"
                      v-if="isTeamlead(team) || isAdmin"
                    >
                      Reservieren
                    </button>
                    <span v-if="!isTeamlead(team) && !isAdmin">-</span>
                  </td>
                  <td v-if="reserving[shift.id]" style="text-align: right">
                    <div class="form">
                      <div class="form-group">
                        <div class="input-group">
                          <input
                            type="text"
                            placeholder="Vorname"
                            class="form-control form-control-sm"
                            v-model="shift.reserved_first_name"
                          />
                          <input
                            type="text"
                            placeholder="Nachname"
                            class="form-control form-control-sm"
                            v-model="shift.reserved_last_name"
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-light btn-sm"
                              @click="reserveShift(team.id, shift)"
                            >
                              <span class="fa fa-check"></span>
                            </button>
                            <button
                              class="btn btn-light btn-sm"
                              @click="reserving[shift.id] = false"
                            >
                              <span class="fa fa-times"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td v-if="editing[shift.id]" style="text-align: right">
                    <div class="form-inline">
                      <div class="form-group">
                        <div class="input-group">
                          <select
                            class="form-control form-control-sm"
                            v-model="shift.user"
                          >
                            <option value="-1">--- Auswählen ---</option>
                            <option
                              v-for="user of users"
                              :value="user.id"
                              :key="user.id"
                            >
                              {{ user.full_name }}
                            </option>
                          </select>
                          <div class="input-group-append">
                            <button
                              class="btn btn-light btn-sm"
                              @click="saveShift(team.id, shift)"
                            >
                              <span class="fa fa-check"></span>
                            </button>
                            <button
                              class="btn btn-light btn-sm"
                              @click="editing[shift.id] = false"
                            >
                              <span class="fa fa-times"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import teamService from "@/services/team.service.js";
import userService from "@/services/user.service.js";
import eventService from "@/services/event.service.js";
import { mapState, mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import { useUserStore } from "@/stores/user.js";
import shiftService from "@/services/shift.service.js";
import taskService from "@/services/task.service.js";
import ConfirmModal from "@/components/ConfirmModal.vue";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import moment from "moment";
import * as Sentry from '@sentry/vue';

export default {
  name: "TeamsView",
  components: { ConfirmModal, HeadlineComponent },
  data() {
    return {
      shifts: { filled: 0, total: 0 },
      teams: [],
      events: [],
      users: [],
      editing: {},
      reserving: {},
      event_id: "",
      teamFilter: "",
      onlyMine: false,
      all_events: false,
    };
  },
  async beforeRouteEnter(to, from, next) {
    let teams = [];
    let events = [];
    let users = [];
    try {
      let response = await eventService.index();
      events = response.data;
      if (events.length) {
        response = await teamService.index(
          to.query.event_id || events[0].id,
          true
        );
        teams = response.data;
      }
      response = await userService.index();
      users = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore().add(
          "danger",
          "Es ist was unerwartetes schief gegangen.."
        );
        window.scrollTo(0, 0);
      }
    }
    next((vm) => {
      vm.events = events;
      if (events.length) {
        if (to.query.event_id) {
          vm.event_id = to.query.event_id;
        } else {
          vm.event_id = events[0].id;
        }
      }
      vm.users = users;
      vm.teams = teams;
      for (let team of vm.teams) {
        if (team.tasks) {
          for (let task of team.tasks) {
            if (task.shifts) {
              for (let shift of task.shifts) {
                vm.shifts.total++;
                if (shift.user) vm.shifts.filled++;
              }
            }
          }
        }
      }
    });
  },
  mounted() {
    // scroll to highligh
    setTimeout(() => {
      if (this.highlight && this.$refs[this.highlight].length > 0) {
        this.$refs[this.highlight][0].scrollIntoView();
      }
    });
  },
  methods: {
    async refresh() {
      let response = await eventService.index(this.all_events);
      this.events = response.data;
      if (this.events.length) {
        this.event_id = this.$route.query.event_id
          ? this.$route.query.event_id
          : this.events[0].id;
        response = await teamService.index(
          this.$route.query.event_id || this.events[0].id,
          true
        );
        this.teams = response.data;
      }
    },
    shiftHasStarted(shift) {
      console.log(shift.start, moment(shift.start));
      return moment(shift.start).isBefore(moment.now());
    },
    async setHasArrived(shift, team_id, hasArrived) {
      try {
        var response = await shiftService.hasArrived(
          this.event_id,
          team_id,
          shift.task_id,
          shift.id,
          hasArrived
        );
        shift.showed_up = response.data.showed_up;
        shift.showed_up_set = response.data.showed_up_set;
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    },
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async updateEvent() {
      var response = await teamService.index(this.event_id, true);
      this.teams = response.data;
      this.$router.replace({ query: { event_id: this.event_id } });
      this.shifts.total = 0;
      this.shifts.filled = 0;
      for (let team of this.teams) {
        if (team.tasks) {
          for (let task of team.tasks) {
            if (task.shifts) {
              for (let shift of task.shifts) {
                this.shifts.total++;
                if (shift.user) this.shifts.filled++;
              }
            }
          }
        }
      }
    },
    isTeamlead(team) {
      if (!team.teamleads) return false;
      for (let tl of team.teamleads) {
        if (tl.id === this.user.id) {
          return true;
        }
      }
      return false;
    },
    async deleteTeam(team) {
      if (
        await this.$refs.confirmModal.show(
          "Team löschen",
          `Soll das Team ${team.name} wirklich gelöscht werden?`
        )
      ) {
        try {
          await teamService.remove(this.event_id, team.id);
          this.addAlert("success", "Das Team wurde erfolgreich gelöscht.");
          for (let i = 0; i < this.teams.length; i++) {
            if (this.teams[i].id === team.id) {
              this.teams.splice(i, 1);
            }
          }
        } catch (e) {
          if (e) {
            Sentry.captureException(e);
            this.addAlert(
              "danger",
              "Es ist was unerwartetes schief gegangen.."
            );
            window.scrollTo(0, 0);
          }
        }
      }
    },
    async deleteTask(task, team) {
      if (
        await this.$refs.confirmModal.show(
          "Aufgabe löschen",
          `Soll die Aufgabe ${task.name} wirklich gelöscht werden?`
        )
      ) {
        try {
          await taskService.remove(this.event_id, team.id, task.id);
          this.addAlert("success", "Die Aufgabe wurde erfolgreich gelöscht.");
          for (let i = 0; i < team.tasks.length; i++) {
            if (team.tasks[i].id === task.id) {
              team.tasks.splice(i, 1);
            }
          }
        } catch (e) {
          if (e) {
            Sentry.captureException(e);
            this.addAlert(
              "danger",
              "Es ist was unerwartetes schief gegangen.."
            );
            window.scrollTo(0, 0);
          }
        }
      }
    },
    async saveShift(team_id, shift) {
      try {
        let response = await shiftService.forceAssign(
          this.event_id,
          team_id,
          shift.task_id,
          shift.id,
          shift.user
        );
        shift.user = response.data.user;
        shift.reserved = response.data.reserved;
        this.addAlert(
          "success",
          "Der Helfer wurde der Schicht erfolgreich zugewiesen."
        );
        this.editing[shift.id] = false;
      } catch (e) {
        if (e) {
          if (e.response && e.response.data.message) {
            this.addAlert("danger", e.response.data.message);
            window.scrollTo(0, 0);
          } else {
            Sentry.captureException(e);
            this.addAlert(
              "danger",
              "Es ist was unerwartetes schief gegangen.."
            );
            window.scrollTo(0, 0);
          }
        }
      }
    },
    async reserveShift(team_id, shift) {
      try {
        let response = await shiftService.update(
          this.event_id,
          team_id,
          shift.task_id,
          shift.id,
          {
            reserved: true,
            reserved_first_name: shift.reserved_first_name,
            reserved_last_name: shift.reserved_last_name,
          }
        );
        shift.user = response.data.user;
        shift.reserved = response.data.reserved;
        shift.reserved_first_name = response.data.reserved_first_name;
        shift.reserved_last_name = response.data.reserved_last_name;
        this.addAlert("success", "Die Schicht wurde erfolgreich reserviert.");
        this.reserving[shift.id] = false;
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    },
    async cancelShift(team_id, shift) {
      if (
        await this.$refs.confirmModal.show(
          "",
          `..., dass der User die Schicht wirklich nicht machen soll?`
        )
      ) {
        try {
          await shiftService.forceCancel(
            this.event_id,
            team_id,
            shift.task_id,
            shift.id
          );
          this.addAlert("success", "Die Schicht wurde erfolgreich abgesagt.");
          delete shift.user;
          shift.reserved = false;
          shift.reserved_first_name = "";
          shift.reserved_last_name = "";
        } catch (e) {
          if (e) {
            Sentry.captureException(e);
            this.addAlert(
              "danger",
              "Es ist was unerwartetes schief gegangen.."
            );
            window.scrollTo(0, 0);
          }
        }
      }
    },
  },
  computed: {
    ...mapState(useUserStore, ["isAdmin", "user"]),
    highlight() {
      return this.$route.query.highlight;
    },
    filteredTeams() {
      var ft = this.teams.filter(
        (el) =>
          el.name.toLowerCase().indexOf(this.teamFilter.toLowerCase()) >= 0
      );
      if (this.onlyMine) {
        ft = ft.filter(
          (el) => el.teamleads.filter((t) => t.id === this.user.id).length > 0
        );
      }
      return ft;
    },
  },
};
</script>

<style scoped>
td {
  height: 48px;
  vertical-align: middle;
}

.form-inline {
  flex-flow: row-reverse;
}
.shift-showed-up {
  background-color: #00ff0014;
}
.shift-not-showed-up {
  background-color: #ff000014;
}

.highlight {
  font-weight: bold;
  box-shadow:
    10px 10px 12px -2px #ff0000,
    -10px -10px 12px -2px #ff0000,
    -10px 10px 12px -2px #ff0000,
    10px -10px 12px -2px #ff0060;
}
</style>
